import axios from "axios";
import React, { useState, useEffect, createContext } from "react";

export const ManagerAuthContext = createContext();

export const ManagerAuthcontexProvider = ({ children }) => {
  const [currentUserRF, setCurrentUserRF] = useState(
    JSON.parse(localStorage.getItem("userT")) || "sis"
  );

  const login = async (inputsRT) => {
    const res = await axios.post(
      "https://clinic.salamatpayanew.ir/AdminLogin",inputsRT);
    setCurrentUserRF(res.data);
  };

  const logout = async (inputsRT) => {
    await axios.post("https://clinic.salamatpayanew.ir/Adminogout");
    setCurrentUserRF("sis");
  };
  useEffect(() => {
    localStorage.setItem("userT", JSON.stringify(currentUserRF));
  }, [currentUserRF]);

  return (
    <ManagerAuthContext.Provider value={{ currentUserRF, login, logout }}>
      {children}
    </ManagerAuthContext.Provider>
  );
};
